import { render, staticRenderFns } from "./MessageContextMenu.vue?vue&type=template&id=7987dfec&scoped=true"
import script from "./MessageContextMenu.vue?vue&type=script&lang=js"
export * from "./MessageContextMenu.vue?vue&type=script&lang=js"
import style0 from "./MessageContextMenu.vue?vue&type=style&index=0&id=7987dfec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7987dfec",
  null
  
)

export default component.exports